<template>
  <m-card902 :image="product.thumbnail" :alt="product.name" class="product-card-902 text-center">
    <h5 class="font-weight-bold product-card-902-title d-block">{{ product.name }}</h5>
    <div class="row product-card-902-content">
      <div v-for="item in result" class="col-12">
        <div class="d-inline-block product-card-902-content-name mx-3">{{ item.name }}</div>
        <div class="d-inline-block product-card-902-content-price-wrapper">
          <p class="d-inline-block product-card-902-content-offer mr-1 overlined-text" v-if="item.offer > 0">
            {{ formatNumber(item.price) }}</p>
          <p class="d-inline-block product-card-902-content-price mr-1 p-0 m-0">{{
              formatNumber(item.priceWithOffer)
            }}</p>
        </div>
      </div>
    </div>
  </m-card902>
</template>

<script>
import {
  calculatePriceAndOffer,
  shoppingCartFunctions
} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions'
import mCard902 from "../../Cards/Card902";
import mA from '../../Tags/A'
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice100 from "../../Product/ProductPrice100";
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {
  productFeatureName,
  productFeatureSubProduct
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "ProductCard902",
  components: {mCard902, mA, mProductCardQuantityManager1, mProductPrice100, mProductOffer1},
  props: {
    product: {},
    showSpecifiedCardFeature: {}
  },
  data() {
    return {
      result: []
    }
  },
  methods: {
    ...shoppingCartFunctions,
    checkItemPushToResultBaseOnshowSpecifiedCardFeature(feature) {
      if (this.showSpecifiedCardFeature.length === 0) {
        return true
      }
      return this.showSpecifiedCardFeature.split(',').indexOf(feature.name) > -1
    },
    productSubProduct() {
      let baseResult = {
        offer: '',
        price: '',
        priceWithOffer: '',
        name: '',
      }


      if (this.product.variation == 1) {
        let subProduct = productFeatureSubProduct(this.product)
        subProduct.forEach(feature => {

          let baseResultDuplicate = Object.assign({}, baseResult)

          let getPriceAndOffer = calculatePriceAndOffer(this.product, feature.id);

          baseResultDuplicate.offer = this.dividePriceToHundred(getPriceAndOffer['offer'])
          baseResultDuplicate.price = this.dividePriceToHundred(getPriceAndOffer['price'])
          baseResultDuplicate.priceWithOffer = this.dividePriceToHundred(getPriceAndOffer['price'] - getPriceAndOffer['offer'])
          baseResultDuplicate.name = productFeatureName(this.product, feature.id)

          if (this.checkItemPushToResultBaseOnshowSpecifiedCardFeature(baseResultDuplicate)) {
            this.result.push(baseResultDuplicate)
          }

        })
      } else {
        let baseResultDuplicate = Object.assign({}, baseResult)
        let getPriceAndOffer = calculatePriceAndOffer(this.product, null);
        console.log(getPriceAndOffer)
        baseResultDuplicate.offer = this.dividePriceToHundred(getPriceAndOffer['offer'])
        baseResultDuplicate.price = this.dividePriceToHundred(getPriceAndOffer['price'])
        baseResultDuplicate.priceWithOffer = this.dividePriceToHundred(getPriceAndOffer['price'] - getPriceAndOffer['offer'])

        baseResultDuplicate.name = ''
        this.result.push(baseResultDuplicate)
      }


    },
    dividePriceToHundred(price) {
      return (parseInt(price) / 1000)
    }
  },
  mounted() {
    this.productSubProduct()
  }
}
</script>

<style scoped>
.product-card-902-content {
  font-size: 1.2rem;
  font-weight: bolder;
}

.product-card-902-title {
  margin-top: 3px;
}

.overlined-text {
  position: relative;
  display: inline-block;
}

.overlined-text::before {
  content: "";
  position: absolute;
  top: 30%;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: red;
}

</style>